<template>
    <div class="input-range-component-two-knobbed-with-text-container">
        <slot name="default"></slot>
    </div>
</template>

<style lang="scss" scoped>
.input-range-component-two-knobbed-with-text-container {
    :deep(.input-range-text-inputs) {
        margin-top: 8px;
        margin-bottom: 10px;
    }
}
</style>
